import { Navigate } from "react-router-dom";
import { useAuthStore } from "../stores/authStore";
import { PageLoader } from "@/components/PageLoader";

/**
 * Page de redirection pour les routes inexistantes.
 * Redirige vers le login si non authentifié, vers le viewer si authentifié.
 */
export const NotFound = () => {
  const { isAuthenticated, isLoading } = useAuthStore();

  if (isLoading) {
    return <PageLoader />;
  }

  return <Navigate to={isAuthenticated ? "/" : "/login"} replace />;
};

export default NotFound;
